/** GST state codes — South India (stored as e.g. "33 - TAMILNADU", max 30 chars). */
export const SOUTH_INDIA_PLACE_OF_SUPPLY_OPTIONS: { value: string; label: string }[] = [
  { value: "33 - TAMILNADU", label: "33 - Tamil Nadu" },
  { value: "32 - KERALA", label: "32 - Kerala" },
  { value: "29 - KARNATAKA", label: "29 - Karnataka" },
  { value: "37 - ANDHRA PRADESH", label: "37 - Andhra Pradesh" },
  { value: "36 - TELANGANA", label: "36 - Telangana" },
  { value: "34 - PUDUCHERRY", label: "34 - Puducherry" },
  { value: "30 - GOA", label: "30 - Goa" },
  { value: "31 - LAKSHADWEEP", label: "31 - Lakshadweep" },
  { value: "35 - ANDAMAN & NICOBAR", label: "35 - Andaman & Nicobar" },
];

export const DEFAULT_PLACE_OF_SUPPLY = "33 - TAMILNADU";

/** Use on invoices/reports when DB value is null or empty. */
export function resolvePlaceOfSupply(
  value?: string | null
): string {
  const v = (value ?? "").trim();
  return v !== "" ? v : DEFAULT_PLACE_OF_SUPPLY;
}
